export default "__VITE_ASSET__Cn398V2m__"